export const getAppURL = () => {
    const baseName = process.env.REACT_APP_BASENAME ? process.env.REACT_APP_BASENAME : process.env.PUBLIC_URL;
    const basePathFiles = process.env.NODE_ENV !== 'development' ? `/${baseName}/` : "";
    const baseNameLogin = process.env.REACT_APP_BASENAME_LOGIN ? process.env.REACT_APP_BASENAME_LOGIN : "login";
    const url = process.env.REACT_APP_URL;
    const urlLogin = process.env.REACT_APP_URL_LOGIN;
    const apiCore = process.env.REACT_APP_APICORE;
    const loginFront = process.env.REACT_APP_FRONTLOGIN;
    const frontDashboard = process.env.REACT_APP_FRONTDASHBOARD;

    const result = {
        baseName,
        basePathFiles,
        baseNameLogin,
        url,
        apiCore,
        loginFront,
        frontDashboard,
        urlLogin,
        salt: "$2a$10$YhD5a/EFtXD3epgqVxdR3O"
    };
    //console.log("app " + JSON.stringify(result));

    return result;
}